import { SafetyCertificateOutlined } from '@ant-design/icons';
import { Button, message, Popconfirm } from 'antd';
import { useState } from 'react';
import baseuri from '../../../methods/baseuri';

interface IResetPassword {
	userId: string;
}

const ResetPassword = ({ userId }: IResetPassword) => {
	const [loading, setloading] = useState(false);

	const handleReset = async () => {
		try {
			setloading(true);
			const res: any = await baseuri.post(`/admin/security/reset-user-password`, {
				userId,
			});

			if (res.status === 200 || res.status === 201) {
				setloading(false);
				message.success(res.data?.message || 'Password reset successful');
			} else {
				setloading(false);
				message.info(res.data?.message || 'Something went wrong');
			}
		} catch (e: any) {
			setloading(false);
			message.error(e.response?.data?.message || 'Failed to reset password');
		}
	};

	return (
		<div>
			<Popconfirm
				title="Are you sure you want to reset this user's password?"
				onConfirm={handleReset}
				okText="Yes"
				cancelText="No"
			>
				<Button
					icon={<SafetyCertificateOutlined />}
					loading={loading}
					danger
				>
					Reset User Password
				</Button>
			</Popconfirm>
		</div>
	);
};

export default ResetPassword;
